import React from 'react';
import { useIntl } from '../../util/reactIntl';

import css from './SectionCancellationPolicyMaybe.module.css';

const SectionCancellationPolicyMaybe = props => {
  const { publicData } = props;
  const intl = useIntl();

  if (!publicData) {
    return null;
  }

  const allowedPolicies = ['flexible', 'strict'];
  const policyFromData = publicData.cancellationPolicy;
  const policy = allowedPolicies.includes(policyFromData) ? policyFromData : 'flexible';
  const isFallbackPolicy = !allowedPolicies.includes(policyFromData);

  const sectionTitle = intl.formatMessage({ id: 'CancellationPolicy.sectionTitle' });
  const label = isFallbackPolicy
    ? intl.formatMessage({ id: 'CancellationPolicy.noPolicyFallback' })
    : intl.formatMessage({ id: `CancellationPolicy.${policy}.label` });
  const description = intl.formatMessage({ id: `CancellationPolicy.${policy}.description` });

  return (
    <section className={css.sectionContainer}>
      <h2 className={css.title}>{sectionTitle}</h2>
      <div className={css.policyContainer}>
        <span className={css.policyLabel}>{label}</span>
        <p className={css.policyDescription}>{description}</p>
      </div>
    </section>
  );
};

export default SectionCancellationPolicyMaybe;